// Module to contain enums
// Most of enums are duplicated and checked on the backend side so it's better to keep it synchronic

// In-app message types (must match backend enums)
export const MessageTypes = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
};

// User roles enum
export const UsersRoles = {
  NONE: 'none',
  ADMIN: 'admin',
  COACH: 'coach',
  PLAYER: 'player',
  FIELDMANAGER: 'field manager',
  PARENT: 'parent',
  REFEREE: 'referee',
  REFEREE_ASSIGNER: 'referee assigner',
};

// Game types enum
export const GameTypes = {
  POOLGAME: 'poolgame',
  PLAYOFF: 'playoff',
};

// Player document's types enum
export const DocTypes = {
  ID: 'ID',
  CERTIFICATE: 'Certificate',
  LICENSE: 'License',
  OTHER: 'Other',
};

// Payment purposes enum
export const PaymentPurposes = {
  CARD: 'card',
  TOURNAMENT: 'tournament',
};

// Payment methods
export const PaymentMethods = {
  SQUARE: 'square',
  CASH: 'cash',
  ZELLE: 'zelle',
  VENMO: 'venmo',
};

// Currencies enum
export const Currencies = {
  USD: 'USD',
};

// A referee's place on a tournament's roster (tournaments/{id}/referees)
export const RefereeStatuses = {
  INVITED: 'invited',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  REVOKED: 'revoked',
};

// Referee payout statuses. Most mirror a PayPal transaction status. FAILED is
// only ever written when the money definitely did not leave; an attempt whose
// outcome we never learned goes to UNKNOWN instead, which must not be repeated
export const PayoutStatuses = {
  // Written locally, not handed to PayPal yet
  PENDING: 'pending',
  PROCESSING: 'processing',
  // Ours: PayPal never answered, so the payout may well have been accepted
  UNKNOWN: 'unknown',
  SUCCESS: 'success',
  UNCLAIMED: 'unclaimed',
  ONHOLD: 'onhold',
  RETURNED: 'returned',
  REVERSED: 'reversed',
  REFUNDED: 'refunded',
  DENIED: 'denied',
  BLOCKED: 'blocked',
  CANCELED: 'canceled',
  FAILED: 'failed',
};

// Statuses under which no money left the account. Everything else counts as
// paid, the in-flight ones among them — PENDING included: the transfer may
// already be on its way, and offering to pay again is offering to pay twice
export const UnpaidPayoutStatuses = [
  PayoutStatuses.FAILED,
  PayoutStatuses.DENIED,
  PayoutStatuses.BLOCKED,
  PayoutStatuses.CANCELED,
  PayoutStatuses.RETURNED,
  PayoutStatuses.REVERSED,
  PayoutStatuses.REFUNDED,
];

// Sports enum
export const Sports = {
  FOOTBALL5V5: 'Football 5v5',
  FLAGFOOTBALL5V5: 'Flag football 5v5',
  FOOTBALL7V7: 'Football 7v7',
  FLAGFOOTBALL7V7: 'Flag football 7v7',
};

// Genders enum
export const Genders = {
  MALE: 'male',
  FEMALE: 'female',
};

// Tour statuses
export const TourStatuses = {
  RUNNING: 'running',
  COMPLETED: 'completed',
  SKIPPED: 'skipped',
};

// Parent statuses
export const ParentStatuses = {
  APPROVED: 'approved',
  PENDING: 'pending',
  REJECTED: 'rejected',
};

// Tournament cut-off dates
export const CutOffDates = {
  AUG_1: 'Aug 1',
  JAN_1: 'Jan 1',
};

// Playoff rounds
export const PlayoffRounds = {
  R128: 'R128',
  R64: 'R64',
  R32: 'R32',
  R16: 'R16',
  QF: 'QF',
  SF: 'SF',
  F: 'F',
};

export const PlayoffRoundOrder = Object.keys(PlayoffRounds);

export const roundIndex = (round) => PlayoffRoundOrder.indexOf(round);

// Human-readable playoff round names (display only)
export const PlayoffRoundNames = {
  R128: 'Round of 128',
  R64: 'Round of 64',
  R32: 'Round of 32',
  R16: 'Round of 16',
  QF: 'Quarterfinal',
  SF: 'Semifinal',
  F: 'Final',
};
